import React from 'react';
import { NumberInput } from '../number-input';
const DextNumberInput = props => {
  return /*#__PURE__*/React.createElement(NumberInput, props);
};
export default DextNumberInput;
//# sourceMappingURL=dext-number-input.js.map